import router from '@/router'
import { useDarkModeStore } from '@/stores/darkMode'
import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import VueAwesomePaginate from 'vue-awesome-paginate'
import './css/main.css'

// Init Pinia
const pinia = createPinia()

// Create Vue app
const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: `rubix-app@${import.meta.env.VITE_APP_VERSION}`,
    environment: import.meta.env.MODE,
    logErrors: true,
    attachStacktrace: true,
    trackComponents: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
  })
}
app.component('VueDatePicker', VueDatePicker)
app.use(router)
app.use(pinia)
app.use(VueAwesomePaginate)
app.config.warnHandler = (msg, _, __) => {
  if (msg.includes('vue3-select-component')) {
    return false // To suppress the warning
  }
  return true
}
app.mount('#app')

// Dark mode
const darkModeStore = useDarkModeStore(pinia)

if (
  (!localStorage['darkMode'] &&
    window.matchMedia('(prefers-color-scheme: dark)').matches) ||
  localStorage['darkMode'] === '1'
) {
  darkModeStore.set(true)
}

// Default title tag
const defaultDocumentTitle = 'Rubix | REACH'
// Set document title from route meta
router.afterEach(to => {
  document.title = to.meta?.title
    ? `${to.meta.title} — ${defaultDocumentTitle}`
    : defaultDocumentTitle
})
